import { PreLanding } from '$shared/components';
import { useCurrentLang, useTranslator } from '$hooks';
import './ModelsLanding.sass';
import { useEffect } from 'react';
import { statReachGoal } from '$utils';

export const ModelsLandingV1 = () => {
  const t = useTranslator();
  const currentLang = useCurrentLang();
  const isRU = currentLang.key === 'ru';

  useEffect(() => {
    statReachGoal('pre_lang_open_1');
  }, []);

  return (
    <PreLanding
      className="ModelsLanding"
      content={[
        {
          mainContent: (
            <div className="ModelsLanding__content__header">
              {t('models_landing_item_1_title')}
            </div>
          ),
          buttons: [
            {
              text: t('models_landing_item_1_button_1'),
              mode: 'inverse',
            },
            {
              text: t('models_landing_item_1_button_2'),
              mode: 'tertiary',
            },
          ],
        },
        {
          mainContent: (
            <>
              <div className="ModelsLanding__content__title">
                {isRU ? (
                  <>
                    {t('models_landing_item_2_title_head')}{' '}
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_item_2_title_body_1')}
                    </span>{' '}
                    и{' '}
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_item_2_title_body_2')}
                    </span>
                  </>
                ) : (
                  <>
                    {t('models_landing_item_2_title_head')}{' '}
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_item_2_title_body')}
                    </span>{' '}
                    {t('models_landing_item_2_title_tail')}
                  </>
                )}
              </div>
              <div className="ModelsLanding__content__caption">
                {t('models_landing_item_2_caption')}
              </div>
            </>
          ),
          buttons: [
            {
              text: t('models_landing_item_2_button_1'),
              mode: 'inverse',
            },
            {
              text: t('models_landing_item_2_button_2'),
              mode: 'tertiary',
            },
          ],
        },
        {
          mainContent: (
            <>
              <div className="ModelsLanding__content__title">
                {isRU ? (
                  <>
                    <>
                      {t('models_landing_item_3_title_head')}{' '}
                      <span className="ModelsLanding__content__text__highlighted">
                        {t('models_landing_item_3_title_body_1')}
                      </span>{' '}
                      и{' '}
                      <span className="ModelsLanding__content__text__highlighted">
                        {t('models_landing_item_3_title_body_2')}
                      </span>
                    </>
                  </>
                ) : (
                  <>
                    {t('models_landing_item_3_title_head')}{' '}
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_item_3_title_body')}
                    </span>
                  </>
                )}
              </div>
              <div className="ModelsLanding__content__caption">
                {t('models_landing_item_3_caption')}
              </div>
            </>
          ),
          buttons: [
            {
              text: `${t('models_landing_item_3_button_1')} 💦`,
              mode: 'inverse',
            },
            {
              text: `${t('models_landing_item_3_button_2')} 🍆`,
              mode: 'inverse',
            },
          ],
        },
        {
          mainContent: (
            <>
              <div className="ModelsLanding__content__title">
                {t('models_landing_item_4_title_head')}{' '}
                <span className="ModelsLanding__content__text__highlighted">
                  {t('models_landing_item_4_title_body')}
                </span>{' '}
                {t('models_landing_item_4_title_tail')}
              </div>
              <div className="ModelsLanding__content__caption">
                {t('models_landing_item_4_caption_1')}
              </div>
              <div className="ModelsLanding__content__caption">
                {t('models_landing_item_4_caption_2')}
              </div>
            </>
          ),
          buttons: [
            {
              text: t('models_landing_item_4_button_1'),
              mode: 'inverse',
            },
            {
              text: t('models_landing_item_4_button_2'),
              mode: 'tertiary',
            },
          ],
        },
        {
          mainContent: (
            <>
              <div className="ModelsLanding__content__title">
                {isRU ? (
                  <>
                    {t('models_landing_item_5_title_head')}{' '}
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_item_5_title_body')}
                    </span>{' '}
                    {t('models_landing_item_5_title_tail')}
                  </>
                ) : (
                  <>
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_item_5_title_head')}
                    </span>{' '}
                    {t('models_landing_item_5_title_tail')}
                  </>
                )}
              </div>
            </>
          ),
          buttons: [
            {
              text: `${t('models_landing_item_5_button_1')} 🍒`,
              mode: 'inverse',
            },
            {
              text: `${t('models_landing_item_5_button_2')} 😈`,
              mode: 'inverse',
            },
          ],
        },
      ]}
    />
  );
};
